import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastType } from '@d-constants';
import { AuthService, ToastService } from '@d-services';
import { AzureSSOService } from '@d-services/other/azure-sso.service';
import { AzureSSOModule } from '@d-shared/azure-sso.module';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { BaseButtonComponent } from '../../core/components/button/button.component';
import { CommonSharedModule } from '../../core/shared/common-shared.module';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  // providers: [AuthService],
  imports: [
    AzureSSOModule,
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    CommonSharedModule,
    BaseButtonComponent,
  ],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });
  isCheckingEmail: boolean = false;
  isNonSSO: boolean = false;
  tokenExpiration: string = '';
  email: string = '';
  constructor(
    private authService: AuthService,
    private toastService: ToastService,

    private azureSSOService: AzureSSOService,
  ) {}

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      window.location.href = '/home';
    }
  }

  onSubmit() {
    if (!this.email) {
      this.loginForm.controls.email.markAsTouched();
      this.loginForm.controls.email.markAsDirty();
      if (this.loginForm.controls.email.valid) {
        this.checkEmail(this.loginForm.value.email);
      }
    } else {
      this.onLoginNonSSO();
    }
  }

  onLoginAzure() {
    this.azureSSOService.generateSSOUrl(this.email).then((url) => {
      window.location.href = url;
    });
  }

  onLoginNonSSO() {
    this.loginForm.markAllAsTouched();
    this.loginForm.markAsDirty();
    if (this.loginForm.valid) {
      this.authService
        .login({
          username: this.email,
          password: this.loginForm.value.password,
        })
        .subscribe(
          (res) => {
            if (res)
              if (res.isSuccess) {
                window.location.href = '/home';
              }
          },
          (err) => {
            this.toastService.addSingle({
              type: ToastType.ERROR,
              message: 'INVALID_USERNAME_OR_PASSWORD',
            });
          },
        );
    }
  }

  onUseDifferentAccount() {
    this.email = '';
    this.loginForm.controls.email.enable();
    this.loginForm.reset();
    this.isNonSSO = false;
  }

  private checkEmail(email: string) {
    if (this.isCheckingEmail) {
      return;
    }
    this.isCheckingEmail = true;
    this.authService
      .checkEmail({ email })
      .pipe(
        catchError((err) => {
          this.isCheckingEmail = false;
          this.toastService.addSingle({
            type: ToastType.ERROR,
            message: 'EMAIL_DOES_NOT_EXIST',
          });
          return of();
        }),
      )
      .subscribe((res) => {
        if (res.isSuccess) {
          this.email = email;
          this.isCheckingEmail = false;
          const { isSSO, isSubsidyAuth } = res.data;
          if (isSubsidyAuth) {
            this.loginForm.controls.email.disable();
            this.isNonSSO = true;
          } else {
            this.onLoginAzure();
          }
        }
      });
  }
}
